import axios from 'axios';
import {
  CREATE_ACCOUNT_BLACKLISTED_CONTACTS,
  CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS,
} from 'constants/analytics';

import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';
import { analyticsTrack } from '../../utils/analytics';

// object
export const CREATE_ACCOUNT_BLACKLISTED_CONTACT_PENDING = 'CREATE_ACCOUNT_BLACKLISTED_CONTACT_PENDING';
export const CREATE_ACCOUNT_BLACKLISTED_CONTACT_FAIL = 'CREATE_ACCOUNT_BLACKLISTED_CONTACT_FAIL';
export const CREATE_ACCOUNT_BLACKLISTED_CONTACT_SUCCESS = 'CREATE_ACCOUNT_BLACKLISTED_CONTACT_SUCCESS';
// objects
export const CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_PENDING = 'CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_PENDING';
export const CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_FAIL = 'CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_FAIL';
export const CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_SUCCESS = 'CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_SUCCESS';


export const createAccountBlacklistedContact = (
  params = {
    account: null,
    contact: null,
  },
  seamless = false,
) => async (dispatch) => {
  analyticsTrack(CREATE_ACCOUNT_BLACKLISTED_CONTACTS, params, true);
  dispatch({
    type: CREATE_ACCOUNT_BLACKLISTED_CONTACT_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline editing
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}account-blacklisted-contacts/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: CREATE_ACCOUNT_BLACKLISTED_CONTACT_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const createBulkAccountBlacklistedContacts = (data = {}, params = {}) => async (dispatch) => {
  analyticsTrack(CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS, params, true);
  dispatch({
    type: CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_PENDING,
    payload: data,
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}account-blacklisted-contacts/bulk/`,
      data,
      { withCredentials: true, params },
    );
    dispatch({
      type: CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};
